/**
 * Remove propriedades com valor null de um objeto.
 *
 * @param {Object} obj - O objeto do qual as propriedades null serão removidas.
 * @returns {Object} O objeto limpo sem as propriedades com valor null.
 *
 * @example
 * const obj = { status: null, name: 'example', age: null };
 * const cleanedObj = removeNullProperties(obj);
 * console.log(cleanedObj); // { name: 'example' }
 */
export function removeNullProperties(obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] === null) {
      delete obj[key];
    }
  });
  return obj;
};
